export const UNSUBSCRIBE_MARKETING = 'unsubscribe-marketing';

export const NO_DURATION = '0';

export const OTHER_REASON = 'OTHER_REASON';
